<span class="px-4 badge cart-status-badge"
      [ngClass]="{
      'badge-canceled':   cartStatus === CartStatus.Cancelled,
      'badge-po_pending': cartStatus === CartStatus.POPending,
      }"
      *ngIf="visible">
  {{ cartStatusDisplayText(cartStatus) }}
</span>
